<template>
  <div class="content">
    <div class="container-fluid mt-7">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template v-slot:header>
            <div class="row align-items-center py-4">
              <div class="col-lg-6 col-8">
                <h3 class="mb-0">Order Table</h3>
              </div>
              <div class="col-lg-6 col-4 text-right">
                <base-button type="primary" size="sm" @click="exportData">
                  <span class="btn-inner--icon text-white"><i class="ni ni-cloud-download-95"></i></span>Export
                </base-button>
              </div>
            </div>
          </template>
          <div>
            <div class="row flex-wrap mb-2 mb-md-0">
              <div class="col-12 col-lg-2 mb-2 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="perPage" placeholder="Per page"
                  @change="handlePerPageChange">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-lg-3 mb-0 mb-lg-2 d-flex justify-content-start">
                <base-input name="date1" class="w-100 ml-2 mr-2">
                  <template v-slot="{ focus, blur }">
                    <flat-picker @on-open="focus" @on-close="blur" :config="{
                      allowInput: true,
                      altFormat: 'd-m-Y',
                      altInput: true,
                      defaultDate: dates.simple
                    }" class="form-control datepicker" v-model="dates.simple">
                    </flat-picker>
                  </template>
                </base-input>
              </div>
              <div class="col-lg-3 mb-2 mt--3 mt-lg-0 d-flex justify-content-start">
                <el-select class="w-100 ml-2 mr-2 pagination-select" v-model="tempFilterField" placeholder="Filter by"
                  @change="handleTempFieldChange">
                  <el-option class="select-primary" v-for="item in fieldOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-lg-3 mb-2 d-flex justify-content-start">
                <base-input v-if="filterField == 'PortfolioName'" name="selectmultiple" class="w-100  ml-2 mr-2">
                  <el-select v-model="tempPortfolioNames" multiple filterable placeholder="Multiple select">
                    <el-option v-for="option in selectOptions" :key="option.label" :label="option.label"
                      :value="formatPortfolioName(option.value)">
                    </el-option>
                  </el-select>
                </base-input>
                <base-input v-else name="select" class="w-100 ml-2 mr-3">
                  <el-select v-model="tempSearchQuery" filterable placeholder="Select value">
                    <el-option v-for="option in selectOptions" :key="option.label" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-lg-1 mb-2 d-flex justify-content-center order-search-height">
                <base-button class="mt-0 mb-4 ml-2 mr-4 px-2" size="md" type="primary" @click="() => {
                  handleSearchChange();
                }">Search</base-button>
              </div>
            </div>
            <modal v-if="isPivot" v-model:show="modals.classic">
              <template v-slot:header>
                <h6 v-if="exitType" class="modal-title">Exit Order</h6>
                <h6 v-else class="modal-title">Entry Order</h6>
              </template>
              <h6 v-if="exitType" class="text-sm">{{ exitType.replace(/_/g, ' ') }}</h6>
              <h6 v-else class="text-sm">{{ strategyName }}</h6>
              <h6 v-if="exitType && pnl" class="text-sm mb-2">P&L :
                <b :class="[pnl > 0 ? 'text-success' : pnl == 0 ? 'text-dark' : 'text-danger']">
                  {{ pnl }}
                </b>
              </h6>
              <table class="table table-bordered mt-2 table-responsive overflow-auto">
                <thead>
                  <tr>
                    <th class="text-dark text-xs">Pivot</th>
                    <th class="text-dark text-xs">Price</th>
                    <th class="text-dark text-xs">Last Updated Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>High Pivot</td>
                    <td>{{ pivotData.highPrice ? pivotData.highPrice.price : 'N/A' }}</td>
                    <td>{{ pivotData.highPrice ? formatTimestamp(pivotData.highPrice.lastUpdatedTime) : 'N/A' }}</td>
                  </tr>
                  <tr>
                    <td>Low Pivot</td>
                    <td>{{ pivotData.lowPrice ? pivotData.lowPrice.price : 'N/A' }}</td>
                    <td>{{ pivotData.lowPrice ? formatTimestamp(pivotData.lowPrice.lastUpdatedTime) : 'N/A' }}</td>
                  </tr>
                  <tr>
                    <td>Temp High</td>
                    <td>{{ pivotData.tempHighPrice ? pivotData.tempHighPrice.price : 'N/A' }}</td>
                    <td>{{ pivotData.tempHighPrice ? formatTimestamp(pivotData.tempHighPrice.lastUpdatedTime) : 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <td>Temp Low</td>
                    <td>{{ pivotData.tempLowPrice ? pivotData.tempLowPrice.price : 'N/A' }}</td>
                    <td>{{ pivotData.tempLowPrice ? formatTimestamp(pivotData.tempLowPrice.lastUpdatedTime) : 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <template v-slot:footer>
                <base-button type="primary" class="ml-auto" @click="modals.classic = false">Close</base-button>
              </template>
            </modal>
            <modal v-if="isCandle" v-model:show="modals.classic">
              <template v-slot:header>
                <h6 v-if="!exitType" class="modal-title">Entry Order</h6>
                <h6 v-else class="modal-title">Exit Order</h6>
              </template>
              <h6 v-if="exitType" class="text-sm mb-2">{{ exitType.replace(/_/g, ' ') }}</h6>
              <h6 v-else class="text-sm">{{ strategyName }}</h6>
              <h6 v-if="exitType && pnl" class="text-sm mb-2">P&L :
                <b :class="[pnl > 0 ? 'text-success' : pnl == 0 ? 'text-dark' : 'text-danger']">
                  {{ pnl }}
                </b>
              </h6>
              <div class="table-responsive overflow-auto h-100">
                <table v-for="(candle, index) in candleData" :key="index" class="table text-sm ">
                  <thead>
                    <tr>
                      <th class="text-dark text-xs">
                        {{ formatDateTimestamp(candle.openTime).date }}
                      </th>
                      <th class="text-dark text-xs">O</th>
                      <th class="text-dark text-xs">H</th>
                      <th class="text-dark text-xs">L</th>
                      <th class="text-dark text-xs">C</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div>Open : {{ formatDateTimestamp(candle.openTime).time }}</div>
                        <div>Close : {{ formatDateTimestamp(candle.closeTime).time }}</div>
                      </td>
                      <td>{{ candle.openPrice || 'N/A' }}</td>
                      <td>{{ candle.highPrice || 'N/A' }}</td>
                      <td>{{ candle.lowPrice || 'N/A' }}</td>
                      <td>{{ candle.closePrice || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <template v-slot:footer>
                <base-button type="primary" class="ml-auto" @click="modals.classic = false">Close</base-button>
              </template>
            </modal>
            <el-table :data="queriedDataWithFullName" row-key="id" header-row-class-name="thead-light"
              @sort-change="handleSortChange" @row-click="handleRowClick" row-class-name="enabled-action">
              <el-table-column label="Sl No" prop="slNo" min-width="120px"></el-table-column>
              <el-table-column label="Order No" prop="id" min-width="160px" sortable></el-table-column>
              <el-table-column label="name" prop="firstName" min-width="200px">
                <template v-slot:default="props">
                  <div class="font-weight-bold">{{ props.row.fullName }} </div>
                </template>
              </el-table-column>
              <el-table-column label="Portfolio Name" prop="portfolioName" min-width="250px">
                <template v-slot:default="props">
                  <div v-if="props.row.portfolioName" class="font-weight-bold">
                    {{ formatPortfolioName(props.row.portfolioName) }} </div>
                  <div v-else class="font-weight-bold">N/A</div>
                </template>
              </el-table-column>
              <el-table-column label="Options Side" prop="optionsSide" min-width="160px">
                <template v-slot:default="props">
                  <span v-if="props.row.optionsSide">{{ props.row.optionsSide }}</span>
                  <span v-else>NA</span>
                </template>
              </el-table-column>
              <el-table-column label="Trade Name" prop="tradeName" min-width="170px"></el-table-column>
            </el-table>
          </div>
          <template v-slot:footer>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <p v-if="isSuccess" class="card-category">
                  Showing {{ from + 1 }} to {{ Math.min(to, total) }} of {{ total }} entries
                </p>
              </div>
              <base-pagination v-if="isSuccess" class="pagination-no-border" v-model="currentPage" :per-page="perPage"
                :total="total" :page-count="totalPages" @update:modelValue="handleFetchNextPage">
              </base-pagination>
            </div>
            <right-sidebar :isVisible="isSidebarVisible" :orderNo="orderNo" :entryOrders="entryOrders"
              :exitOrders="exitOrders" :order="selectedRowData" @close="isSidebarVisible = false"
              @showModalData="handleShowModalData">
            </right-sidebar>
          </template>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import BasePagination from "@/components/BasePagination";
import RightSidebar from "./RightSidebar";
import { emitter } from '../System/emitter';
import Modal from "@/components/Modal";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";

export default {
  components: {
    BasePagination,
    RouteBreadCrumb,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
    RightSidebar,
    Modal,
    flatPicker,
  },
  computed: {
    pagedData() {
      return this.tableData;
    },
    queriedData() {
      return this.tableData;
    },
    queriedDataWithFullName() {
      const startIndex = this.from + 1;
      return this.queriedData.map((item, index) => ({
        ...item,
        fullName: `${item.firstName} ${item.lastName}`,
        slNo: startIndex + index,
      }));
    },
    from() {
      return (this.currentPage - 1) * this.perPage;
    },
    to() {
      return Math.min(this.from + this.perPage, this.total);
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      totalElements: 0,
      totalPages: 0,
      total: 0,
      searchQuery: '',
      tempSearchQuery: '',
      direction: "DESC",
      sortedColumn: "id",
      tableData: [],
      searchedData: [],
      isSuccess: false,
      searchedData: [],
      isSidebarVisible: false,
      selectedRowData: '',
      entryOrders: [],
      exitOrders: [],
      fieldOptions: ['Portfolio Name', 'Trading Instrument', 'Trade Name'],
      filterField: '',
      tempFilterField: '',
      modals: {
        classic: false,
      },
      pivotData: {},
      candleData: [],
      isCandle: false,
      isPivot: false,
      strategyName: '',
      dates: {
        simple: new Date().toISOString().split("T")[0],
      },
      portfolioNames: [],
      tempPortfolioNames: [],
      selectOptions: [],
      isDownloadSuccess: false,
      pnl: '',
    };
  },
  methods: {
    formatTimestamp(lastUpdatedTime) {
      return moment(lastUpdatedTime).format('DD/MM/YYYY HH:mm:ss');
    },
    formatDateTimestamp(timestamp) {
      return {
        date: moment(timestamp).format('DD/MM/YYYY'),
        time: moment(timestamp).format('HH:mm:ss')
      };
    },
    handleRowClick(row) {
      this.selectedRowData = row;
      this.isSidebarVisible = true;
      let data = {
        id: row.id,
      };
      this.$store.dispatch("orderStore/getOrderById", data, { root: true })
        .then(response => {
          this.strategyName = response.server.data.strategyName;
          this.entryOrders = response.server.data.entryOrders;
          this.exitOrders = response.server.data.exitOrders;
        })
        .catch(error => {
          console.log(error);
        });
    },
    setTable(pageNo, pageSize, sortBy, direction, filter, filterField, fromDate, toDate, portfolioNames) {
      let data = {
        pageNo: pageNo - 1,
        pageSize: pageSize,
        sortBy: sortBy,
        direction: direction,
        filter: filter,
        filterField: filterField,
        fromDate: fromDate,
        toDate: toDate,
        portfolioNames: portfolioNames
      };
      this.$store.dispatch("orderStore/getOrderDetails", data, { root: true })
        .then(response => {
          this.tableData = response.server.data.orderTableBean;
          this.totalElements = this.tableData.length;
          this.currentPage = response.server.data.currentPage + 1;
          this.totalPages = response.server.data.totalPages;
          this.total = response.server.data.totalElements;
          this.isSuccess = this.tableData.length > 0;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSortChange({ prop, order }) {
      let sortProp = prop || 'id';
      let sortOrder = order || 'ascending';
      this.setTable(this.currentPage, this.perPage, sortProp, this.mapSortOrder(sortOrder), this.searchQuery, this.filterField, this.dates.simple, this.dates.simple, this.portfolioNames);
    },
    mapSortOrder(order) {
      const orderMap = {
        "ascending": "ASC",
        "descending": "DESC",
      };
      return orderMap[order];
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField, this.dates.simple, this.dates.simple, this.portfolioNames);
    },
    handleFetchNextPage(newPage) {
      this.currentPage = newPage;
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField, this.dates.simple, this.dates.simple, this.portfolioNames);
    },
    handleTempFieldChange() {
      this.tempSearchQuery = '';
      this.filterField = this.tempFilterField.replace(/ /g, '');
      let data = {
        type: ""
      };
      if (this.filterField == 'TradeName') {
        data.type = 'trade-term'
      } else if (this.filterField == 'TradingInstrument') {
        data.type = 'instrument-code'
      } else if (this.filterField == 'PortfolioName') {
        data.type = 'portfolio-name'
      } else {
        data.type = 'user-name'
      }
      if (sessionStorage.getItem(data.type + "-reference-data")) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
      } else {
        this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
          .then(response => {
            this.selectOptions = response.server.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    handleSearchChange() {
      this.portfolioNames = this.formatPortfolioList(this.tempPortfolioNames);
      this.searchQuery = this.tempSearchQuery;
      this.setTable(1, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField, this.dates.simple, this.dates.simple, this.portfolioNames);
    },
    formatPortfolioName(name) {
      return name
        .split('_')
        .map(word => {
          return /^[a-zA-Z]+$/.test(word)
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : word;
        })
        .join(' ');
    },
    formatPortfolioList(portfolioList) {
      return portfolioList.map(item =>
        String(item)
          .toUpperCase()
          .replace(/\s+/g, '_')
          .replace(/(\d+)L$/, '$1L')
      );
    },
    async handleShowModalData(showModal, data, pnl, exitType) {
      this.candleData = [];
      this.pivotData = {};
      this.exitType = '';
      this.pnl = '';
      this.isCandle = false;
      this.isPivot = false;
      this.modals.classic = false;
      if (showModal) {
        this.exitType = exitType;
        this.pnl = pnl.toFixed(2);
        this.isCandle = true;
        if (data != null) {
          if (Array.isArray(data)) {
            this.isCandle = true;
            this.candleData = data;
            await this.$nextTick();
          } else {
            this.isCandle = false;
            this.isPivot = true;
            this.pivotData = data;
          }
        }
        this.modals.classic = showModal;
      }
    },
    exportData() {
      let data = {
        type: "DAILY",
        from: this.dates.simple,
        to: this.dates.simple,
      }
      this.$store.dispatch("orderStore/getOrderReport", data, { root: true })
        .then(response => {
          const blob = new Blob([response.data], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `order_report_${this.getFormattedDateTime(this.dates.simple)}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.isDownloadSuccess = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getFormattedDateTime(date) {
      const m = moment(date);
      if (m.isSame(moment(), "day")) {
        return moment().format("DD-MM-YYYY_HH-mm-ss");
      } else {
        return m.format("DD-MM-YYYY_HH-mm-ss");
      }
    }
  },
  mounted() {
    this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField, this.dates.simple, this.dates.simple);
    emitter.on('flag-sent', (data) => {
      this.setTable(this.currentPage, this.perPage, this.sortedColumn, this.direction, this.searchQuery, this.filterField, this.dates.simple, this.dates.simple);
    });
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
